import { useAssetStore, useUiStore } from '../../../../../store'
import { GSection, GTooltip } from '../../../../../components/basic-blocks'
import { HelpCircle as RiQuestionLine } from 'components/icons'
import { generateReportTitle } from '../types'
import { capitalizeFirstLetter } from '../../../../../utils/text'
import moment from 'moment'
import { useShallow } from 'zustand/react/shallow'
import { NavLink } from 'react-router-dom'
import { HelpCircle as AiOutlineQuestionCircle } from 'components/icons'
export const UpcomingReports = () => {
	const { asset, reportRequests } = useAssetStore(
		useShallow((s) => ({
			asset: s.asset,
			reportRequests: s.reportRequests
		}))
	)
	const isLoading = useUiStore((s) => s.isLoading('ASSET_GET_REPORT_REQUESTS'))
	return (
		<GSection containerClassName="w-full !mb-0" loading={isLoading} borderClass="border border-t-border-light rounded-xl">
			<div className="h-[300px]">
				<div className="flex items-center justify-between w-full pb-6">
					<div className="flex gap-x-2 items-center text-lg font-medium">
						Upcoming reports
						<GTooltip
							position="top"
							arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent  border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
							contentClassName="border-none mb-2 bg-t-smoke max-w-xs font-medium text-sm text-t-desc-gray"
							content="This shows the upcoming reports that you have scheduled.">
							<AiOutlineQuestionCircle
								className="text-t-gray-hold w-4 h-4" />
						</GTooltip>
					</div>
					<NavLink
						to={`/workspace/${asset?.account_id}/asset/${asset?.id}/reports?tab=scheduled`}
						className="h-[34px] w-[100px] rounded-full font-medium border flex items-center justify-center"
					>
						Configure
					</NavLink>
				</div>
				{!isLoading && reportRequests.length === 0 ? (
					<div className="flex items-center justify-center pt-8">
						<p>No upcoming reports available</p>
					</div>
				) : (
					<div className="flex flex-col gap-6">
						{reportRequests
							.filter((f) => f.status === 'ACTIVE')
							.map((s) => {
								return (
									<div key={s.id} className="flex items-center justify-between">
										<p>{generateReportTitle(s)}</p>
										<p className='text-t-desc-gray'>
											{capitalizeFirstLetter(
												'In ' + moment(s.scheduled_for).fromNow(true)
											)}
										</p>
									</div>
								)
							})}
					</div>
				)}
			</div>
		</GSection>
	)
}
